import moment from 'moment';
import Vue from 'vue';

const DEFAULT_FORMAT = 'YYYY-MM-DD HH:mm:ss';

/**
 * Jackson 等常把 LocalDateTime 序列化为 [y, M, d, h, m, s(, nano)]，其中 M 为 1–12。
 * moment / JS Date 的月份为 0–11，直接 moment(arr) 会把 5 当成「六月」。
 */
function normalizeMomentInput(value) {
  if (
    Array.isArray(value) &&
    value.length >= 6 &&
    typeof value[0] === 'number' &&
    value[0] >= 1970 &&
    value[0] <= 2100 &&
    typeof value[1] === 'number' &&
    value[1] >= 1 &&
    value[1] <= 12
  ) {
    const copy = value.slice();
    copy[1] = value[1] - 1;
    return copy;
  }
  return value;
}

Vue.filter('moment', (value, format = DEFAULT_FORMAT) => {
  if (!value) return '';

  return moment(normalizeMomentInput(value)).format(format);
});
